import React, { useState } from "react";
import { GoArrowRight } from "react-icons/go";
import { useSearchParams } from "react-router-dom";
import img_placehlder from "../../../../assets/imagePlacehplder.png";
import edit_icon from "../../../../assets/edit_img.png";
import { DatePicker, Input, Select } from "../../../../components/header/form";
import { imageHandler } from "../../../../utils/imageHandler";
import PhoneInput from "react-phone-input-2";
import {
  allowAlphaNumericWithLeadingAlpha,
  areMandatoryFieldsFilled,
} from "../../../../utils/inputValueValidation";
import { gender, twelveYearsAgo } from "../../../../utils/staticData";
import { isoTimeFormat } from "../../../../utils/dateTimeFormat";
import { decryptData } from "../../../../utils/dataCipher";

const PersonalInfo = ({
  registrationStepperHandler,
  setImage,
  image,
  registrationData,
}) => {
  const [searchParam, setSearchParam] = useSearchParams();

  let phoneInfo = searchParam.get("info") || {};
  let encryptedData;

  // Get the query string (encrypted data)
  if (Object.keys(phoneInfo).length) {
    encryptedData = decryptData(phoneInfo);
  }

  // Get the query string (encrypted data)
  const [dateOfBirth, setDateOfBirth] = useState(
    registrationData?.dateOfBirth || ""
  );
  const [userData, setUserData] = useState({
    fullName: registrationData?.fullName || "",
    nickname: registrationData?.nickname || "",
    email: registrationData?.email || "",
    gender: registrationData?.gender || "",
  });
  // console.log('userData', userData)
  const [phone, setPhone] = useState({
    dialCode: encryptedData?.dialCode || "+1",
    number: encryptedData?.number || "",
    completeMobile: encryptedData?.dialCode + encryptedData?.number,
  });
  const requiredFields = ["fullName", "email", "gender"];

  const formFields = {
    fullName: userData?.fullName,
    email: userData?.email,
    gender: userData?.gender,
    // dateOfBirth: dateOfBirth,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "fullName") {
      setUserData({
        ...userData,
        [name]: allowAlphaNumericWithLeadingAlpha(value),
      });
    } else if (name === "nickname") {
      setUserData({
        ...userData,
        [name]: allowAlphaNumericWithLeadingAlpha(value),
      });
    } else {
      setUserData({ ...userData, [name]: value });
    }
  };

  const handlePhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country.dialCode, "");
    setPhone({
      number: phoneWithoutCountryCode,
      completeMobile: `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      dialCode: `+${country?.dialCode}`,
    });
  };

  const nextFormHandler = (e) => {
    e.preventDefault();
    registrationStepperHandler("additionalInfo", {
      ...userData,
      ...phone,
      // dateOfBirth: isoTimeFormat(dateOfBirth),
    });
  };

  return (
    <div className="wrap_profile">
      <h2>Create a profile</h2>

      <div className="user_icon">
        <img
          src={(image?.name && URL.createObjectURL(image)) || img_placehlder}
        />
        <input
          type="file"
          id="profile_picture"
          accept="image/*"
          onChange={(e) => imageHandler(e, setImage, "image", null)}
        />
        <label htmlFor="profile_picture" className="edit-icon">
          <img src={edit_icon} />
        </label>
      </div>

      {/* <form> */}
      <div className="form_field_wrap">
        <div className="form_field">
          <Input
            required
            label="Your Name"
            name="fullName"
            value={userData?.fullName || ""}
            onChange={handleChange}
            maxlength="50"
            className="input form-control"
            type="text"
            id="name"
            placeholder="Enter Your Name"
          />
        </div>
        <div className="form_field">
          <Input
            label="Nick Name"
            name="nickname"
            value={userData?.nickname || ""}
            onChange={handleChange}
            maxlength="50"
            type="text"
            id="nickname"
            className="input form-control"
            placeholder="Enter Nick Name (Optional)"
          />
        </div>
      </div>

      <div className="form_field_wrap">
        <div className="form_field">
          <Input
            required
            label="Email Address"
            name="email"
            value={userData?.email || ""}
            onChange={handleChange}
            maxlength="50"
            className="input form-control"
            type="email"
            id="email"
            placeholder="Enter Email Address"
          />
        </div>
        <div className="form_field">
          <label htmlFor="" className="label">
            Contact Number{" "}
          </label>
          <div className="phone_input">
            <PhoneInput
              country={"ca"}
              disabled
              value={phone?.completeMobile || "+1"}
              enableSearch={true}
              placeholder={"Enter Mobile Number"}
              countryCodeEditable={false}
              onChange={handlePhoneChange}
              // className="input form-control"
            />
          </div>
        </div>
      </div>

      <div className="form_field_wrap">
        {/* <div className="form-group">
          <DatePicker
            required
            className="input form-control"
            label=" Date of Birth"
            value={dateOfBirth || ""}
            onChange={(date) => setDateOfBirth(date)}
            maxDate={twelveYearsAgo}
            placeholder="Select Date of Birth"
          />
        </div> */}
        <div className="form-group">
          <Select
            label="Gender"
            required
            className="input form-control select_arrow"
            id="gender"
            name="gender"
            value={userData?.gender}
            onChange={handleChange}
          >
            <option value="" disabled selected>
              Select Your Gender
            </option>
            {gender?.map((data) => (
              <option value={data?.value} key={data?.value}>
                {data?.name}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <button
        disabled={!areMandatoryFieldsFilled(formFields, requiredFields)}
        onClick={nextFormHandler}
        className={`button next-button ${
          !areMandatoryFieldsFilled(formFields, requiredFields)
            ? "cstm_disabled_btn"
            : ""
        }`}
      >
        Next &nbsp;
        <GoArrowRight />
      </button>
      {/* </form> */}
    </div>
  );
};

export default PersonalInfo;
